<template>
  <v-hover>
    <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto" max-width="350" style="margin: 1em;">
      <v-img class="white--text align-end" height="200px" style="filter: brightness(50%);" v-bind:src="require(`@/assets/img/${Tclass.image}`)"></v-img>
      <v-card-title class="text-center">{{ Tclass.title }}</v-card-title>
      <v-card-text class="text--primary">

        <div>{{ Tclass.description }}</div>
      </v-card-text>

      <router-link to="/Class" style="text-decoration: none; color: #EAC67A;">
        <v-card-actions>
          <v-btn color="amber">
            GO
          </v-btn>
        </v-card-actions>
      </router-link>


    </v-card>
  </v-hover>
</template>

<script>

  export default {
    props: ['Tclass'],

    components: {
    },
  };
</script>

<style>

</style>
